import PropTypes from 'prop-types';
import React, { Fragment, useContext, useState } from "react";
import { Alert } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { NavLink } from "react-router-dom";

import ScrollMenu from 'react-horizontal-scrolling-menu';
import ProtocolContext from "../../../containers/Protocols/ProtocolContext/ProtocolContext";
import { formStatus, patientInProtocolStatus, visitStage, visitStatus, visitTypes } from "../../../variables/Enums";
import { WithAuth } from "../../Authorization/WithAuthProtocol";
import Card from "../../Cards/Card";
import { Italic } from "../../CustomControls/CustomTextStyle";
import { Audit, Back, Cancel, Change, Check, Contract, Drug, Expand, Export, ExtraProtocol, Next, Phone, VideoCall, Publish, Remove, Save, Swap, Sync, Warning } from "../../Icons/Icons";
import { toLocaleDateTimeFormatter, visitStatusFormatter } from "../../Utils/Formatter";
import { Tooltip } from '../../Utils/Tooltips';
import { getVisitTypeTitle } from '../../../containers/Protocols/Tracking/Services';

export const FormMenu = (props) => {
  const [showAdditionals, setShowAdditionals] = useState(false);
  const { t } = useTranslation();
  const handleOthersClick = () => { setShowAdditionals(!showAdditionals); }

  const additionals = props.forms.filter(x => x.extraFormType === 0).map(function (form, index) {
    return (<button
      key={`button_additionals_${index}`}
      type="button"
      className={`btn ${form.id === props.selectedFormId ? "btn-primary" : "btn-default"} btn-full btn-fill`}
      onClick={() => props.onClick(form.id)}
      style={{ marginBottom: '5px', textAlign: 'left' }}>

      {form.status === 1 ? <Save style={{ marginRight: '5px' }} /> : ''}
      {props.formsWithErrors?.find(x => x.id === form.id) ? <Warning style={{ marginRight: '5px' }} /> : ''}
      {form.title}
    </button>);
  });

  const content = props.forms.filter(x => x.extraFormType !== 0).map(function (form, index) {
    return (<button
      key={`button_content_${index}`}
      type="button"
      className={`btn ${form.id === props.selectedFormId ? "btn-primary" : "btn-default"} btn-full btn-fill`}
      onClick={() => props.onClick(form.id)}
      style={{ marginBottom: '5px', textAlign: 'left' }}>

      {form.status === 1 ? <Save style={{ marginRight: '5px' }} /> : ''}
      {props.formsWithErrors?.find(x => x.id === form.id) ? <Warning style={{ marginRight: '5px' }} /> : ''}
      {form.title}
    </button>);
  });

  if (additionals.length > 0)
    content.push(
      <button
        key="button_additional"
        type="button"
        className="btn btn-default btn-fill btn-full"
        onClick={(handleOthersClick)}
        style={{ marginBottom: '5px', textAlign: 'left' }}>
        {showAdditionals ? <Contract /> : <Expand />} {t("protocols.extraForms.additionals")}
      </button>
    );

  if (props.forms.length == 0) return null;
  return (
    <Card
      content={
        <>
          {!props.isDisabled && content}
          {showAdditionals && additionals}
        </>
      }
    />
  );
}

FormMenu.propTypes = {
  onClick: PropTypes.func.isRequired,
  forms: PropTypes.array.isRequired,
  formsWithErrors: PropTypes.array.isRequired,
  selectedFormId: PropTypes.number,
};

export const FormActions = (props) => {
  const {
    onBack,
    onSave,
    onSaveUpload,
    onSkip,
    onScreenFailure,
    onLostToFollowUp,
    onAuditTrail,
    onWithoutDrugs,
    onReturnDrugs,
    onDiscontinuation,
    onReSync,
    onChangeType,
    onChangeVisitTrackingType,
    onRollbackVisitStatus,
    onRemove,
    onExport,
      onEndPatientInProtocol,
      onAssignBranch,
      canAssignBranch,
    visit,
    hasVisitTracking,
    forms,
    isSubmitting,
    hasMissingConsents,
    disabled
  } = props;

  const { t } = useTranslation();
  const context = useContext(ProtocolContext);
  const protocolId = context.protocolId;

  if (!visit)
    return null;

    return (
        <Card
            title={t('medicalRecords.actions')}
            className="card-actions"
            content={
                <Fragment>
                    <WithAuth protocolId={protocolId} requiredPermission={["VisitTracking.UploadFile"]}>
                        {   // Subir Adjunto. 
                            hasVisitTracking &&
                            <button
                                type="button"
                                className="btn btn-primary btn-full "
                                onClick={onSaveUpload}
                                    disabled={isSubmitting || context.isDisabled || disabled || hasMissingConsents}
                            >
                                <Save style={{ marginRight: '5px' }} />{t('protocols.visitTracking.saveUploadChanges')}
                            </button>
                        }
                    </WithAuth>
                    <WithAuth protocolId={protocolId} requiredPermission={["VisitTracking.Add"]}>
                        {   // Guardar Visita. 
                            hasVisitTracking &&
                            <button
                                type="button"
                                className="btn btn-primary btn-full "
                                onClick={() => onSave()}
                                    disabled={isSubmitting || context.isDisabled || disabled || hasMissingConsents}
                            >
                                <Save style={{ marginRight: '5px' }} />{t('protocols.visitTracking.saveChanges')}
                            </button>
                        }
                    </WithAuth>
                    {
                        hasVisitTracking &&
                        <WithAuth protocolId={protocolId} requiredPermission={["VisitTracking.Publish"]}>
                            { // Publicar visita. 
                                (visit.status !== visitStatus.Failed && visit.status !== visitStatus.Skipped && visit.status !== visitStatus.Completed) &&
                                <button
                                    type="submit"
                                    name="publish"
                                    className="btn btn-success btn-full"
                                            disabled={isSubmitting || context.isDisabled || disabled || hasMissingConsents || visit.status == visitStatus.Skipped || visit.status == visitStatus.Failed ? true : false}
                                >
                                    <Publish style={{ marginRight: '5px' }} />
                                    {visit.status === visitStatus.Changed && t('protocols.visitTracking.publishChanges')}
                                    {visit.status !== visitStatus.Changed && t('protocols.visitTracking.publish')}
                                </button>
                            }
                            { // Eliminar visita. 
                                (
                                    (visit.status === visitStatus.Started || visit.status === visitStatus.AutoCompleted) &&
                                    forms.filter(x => x.status > formStatus.Initial).length === 0
                                ) &&
                                <button
                                    type="button"
                                    name="remove"
                                    className="btn btn-danger btn-full"
                                    onClick={() => onRemove()}
                                    disabled={isSubmitting || context.isDisabled || disabled}
                                >
                                    <Remove style={{ marginRight: '5px' }} />{t('protocols.visitTracking.remove')}
                                </button>
                            }
                            { // Sincronizar. 
                                    (visit.status === visitStatus.Completed || visit.status === visitStatus.Failed) &&
                                <button
                                    type="button"
                                    name="publish"
                                    className="btn btn-warning btn-full"
                                    disabled={isSubmitting || context.isDisabled || disabled || (visit.status !== visitStatus.Completed && visit.status !== visitStatus.Failed) }
                                    onClick={onReSync}
                                >
                                    <Sync style={{ marginRight: '5px' }} />
                                    {t('protocols.visitTracking.resync')}
                                </button>
                            }
                        </WithAuth>
                    }
                    {
                        hasVisitTracking &&
                        <WithAuth protocolId={protocolId} requiredPermission={["VisitTracking.Add", "VisitTracking.Publish"]}>
                            <>
                                { // Terminar participación del paciente en el protocolo
                                    (
                                        (visit.stage === visitStage.FollowUp) && (visit.status === visitStatus.Completed || visit.status === visitStatus.Changed) &&
                                        props.patientInProtocolStatus !== patientInProtocolStatus.EndParticipationInProtocol
                                    ) &&
                                    <button
                                        type="button"
                                        className="btn btn-warning btn-full "
                                        onClick={onEndPatientInProtocol}
                                        disabled={isSubmitting || context.isDisabled || disabled}
                                    >
                                        <Warning style={{ marginRight: '5px' }} />{t('protocols.visitTracking.endPatientInProtocol')}
                                    </button>
                                }
                                { // Saltear
                                    (visit.status === visitStatus.Started || visit.status === visitStatus.AutoCompleted) &&
                                    <button
                                        type="button"
                                        className="btn btn-warning btn-full "
                                        onClick={onSkip}
                                        disabled={isSubmitting || context.isDisabled || disabled}
                                    >
                                        <Cancel style={{ marginRight: '5px' }} />{t('protocols.visitTracking.skipVisitTracking')}
                                    </button>
                                }
                                { // Asignar Rama
                                    canAssignBranch &&
                                    <button
                                        type="button"
                                        className="btn btn-info btn-full"
                                        onClick={onAssignBranch}
                                        disabled={isSubmitting || context.isDisabled || disabled}
                                    >
                                        <Check style={{ marginRight: '5px' }} />{t('protocols.branches.assignBranch')}
                                    </button>
                                }
                                { // Falla Screening (En visita Screening (siempre muestro) y Random si esta ultima nunca fue guardada (el paciente sigue en screening si nunca se completó))
                                    (
                                        props.patientInProtocolStatus !== patientInProtocolStatus.Failed &&
                                        (visit.stage === visitStage.Screening) || // En screening, siempre muestro
                                        (props.patientInProtocolStatus == patientInProtocolStatus.PreScreening) || // En PreScreening siempre muestro
                                        (visit.stage === visitStage.Random && (visit.status === visitStatus.Started || visit.status === visitStatus.AutoCompleted))
                                    ) &&
                                    <button
                                        type="button"
                                        className="btn btn-danger btn-full "
                                        onClick={onScreenFailure}
                                        disabled={isSubmitting || context.isDisabled || disabled}
                                    >
                                        <Warning style={{ marginRight: '5px' }} />{t('protocols.visitTracking.screenFailure')}
                                    </button>
                                }
                                { // Falla Seguimiento (Random, Treatment, FollowUp)
                                    (
                                        (
                                            (props.patientInProtocolStatus == patientInProtocolStatus.Random) ||
                                            (props.patientInProtocolStatus == patientInProtocolStatus.Treatment) ||
                                            (props.patientInProtocolStatus == patientInProtocolStatus.FollowUp) ||
                                            props.patientInProtocolStatus === patientInProtocolStatus.WithoutDrugs
                                        )
                                        &&
                                        (visit.status === visitStatus.Started || visit.status === visitStatus.AutoCompleted)
                                    ) &&
                                    <button
                                        type="button"
                                        className="btn btn-danger btn-full "
                                        onClick={onLostToFollowUp}
                                        disabled={isSubmitting || context.isDisabled || disabled}
                                    >
                                        <Warning style={{ marginRight: '5px' }} />{t('protocols.visitTracking.lostToFollowUp')}
                                    </button>
                                }
                                { // Discontinuacion (Visible siempre, en cualquier estado de visita), salvo visita de PreScreening
                                    (visit.status !== visitStatus.Failed && visit.status !== visitStatus.Skipped && (visit.stage == visitStage.Treatment || visit.stage == visitStage.FollowUp)) &&
                                    <button
                                        type="button"
                                        className="btn btn-danger btn-full"
                                        onClick={onDiscontinuation}
                                        disabled={isSubmitting || context.isDisabled || disabled}
                                    >
                                        <Warning style={{ marginRight: '5px' }} />{t('protocols.visitTracking.discontinuation')}
                                    </button>
                                }
                                { // Rollback Visit Status
                                    (visit.status === visitStatus.Skipped ||
                                        (
                                            props.patientInProtocolStatus === patientInProtocolStatus.Failed ||
                                            props.patientInProtocolStatus === patientInProtocolStatus.LostToFollowUp ||
                                            props.patientInProtocolStatus === patientInProtocolStatus.Discontinuation ||
                                            props.patientInProtocolStatus === patientInProtocolStatus.EndParticipationInProtocol
                                        )) &&
                                    <button
                                        type="button"
                                        className="btn btn-info btn-full "
                                        onClick={onRollbackVisitStatus}
                                        disabled={isSubmitting || context.isDisabled || disabled}
                                    >
                                        <Warning style={{ marginRight: '5px' }} />{t('protocols.visitTracking.rollbackStatus')}
                                    </button>
                                }
                                { // Sin Medicacion
                                    (
                                        (visit.stage === visitStage.Treatment) &&
                                        (visit.status === visitStatus.Started || visit.status === visitStatus.AutoCompleted) &&
                                        (props.patientInProtocolStatus !== patientInProtocolStatus.WithoutDrugs)
                                    ) &&
                                    <button
                                        type="button"
                                        className="btn btn-info btn-full "
                                        onClick={onWithoutDrugs}
                                        disabled={isSubmitting || context.isDisabled || disabled}
                                    >
                                        <Drug style={{ marginRight: '5px' }} />{t('protocols.visitTracking.withoutDrugs')}
                                    </button>
                                }
                                { // Retornar Medicacion
                                    (
                                        (visit.stage == visitStage.Treatment) &&
                                        (visit.status === visitStatus.Started || visit.status === visitStatus.AutoCompleted) &&
                                        (props.patientInProtocolStatus === patientInProtocolStatus.WithoutDrugs)
                                    ) &&
                                    <button
                                        type="button"
                                        className="btn btn-info btn-full "
                                        onClick={onReturnDrugs}
                                        disabled={isSubmitting || context.isDisabled || disabled}
                                    >
                                        <Drug style={{ marginRight: '5px' }} />{t('protocols.visitTracking.returnDrugs')}
                                    </button>
                                }
                                { // Cambiar tipo (Protocolar/ExtraProtocolar) Solo permito cambio si nunca fue guardada (Status Started)
                                    ((visit.stage > visitStage.Screening) && (visit.status === visitStatus.Started || visit.status === visitStatus.AutoCompleted)) &&
                                    <button
                                        type="button"
                                        className="btn btn-warning btn-full "
                                        onClick={onChangeVisitTrackingType}
                                        disabled={isSubmitting || context.isDisabled || disabled}
                                    >
                                        <Change style={{ marginRight: '5px' }} />{t('protocols.visitTracking.changeVisitTrackingType')}
                                    </button>
                                }
                                { // Cambiar tipo (Presencial/Telefónica)
                                    ((visit.stage > visitStage.Random) && (visit.status === visitStatus.Started || visit.status === visitStatus.AutoCompleted)) &&
                                    <button
                                        type="button"
                                        className={`btn btn-primary btn-fill btn-full`}
                                        onClick={onChangeType}
                                        disabled={isSubmitting || context.isDisabled || disabled}>
                                        <Swap /> {t('buttons.changeType')}
                                    </button>
                                }
                            </>
                        </WithAuth>
                    }

                    <WithAuth protocolId={protocolId} requiredPermission={["VisitTracking.ExportPatientVisit"]}>
                        {
                            hasVisitTracking &&
                            <button
                                type="button"
                                className="btn btn-success btn-full "
                                onClick={onExport}
                                disabled={isSubmitting}
                            >
                                <Export style={{ marginRight: '5px' }} />{t('protocols.visitTracking.export')}
                            </button>
                        }
                    </WithAuth>
                    <WithAuth protocolId={protocolId} requiredPermission={["VisitTracking.View"]}>
                        <button className={`btn btn-primary btn-fill btn-full`} onClick={onBack} disabled={isSubmitting}>
                            <Back /> {t('buttons.back')}
                        </button>
                    </WithAuth>
                    <button className={`btn btn-primary btn-fill btn-full`} onClick={props.onBackToMR} disabled={isSubmitting}>
                        <Back /> {t('protocols.visitTracking.viewMR')}
                    </button>
                    {
                        hasVisitTracking && <button
                            type="button"
                            disabled={isSubmitting}
                            className="btn btn-audit btn-fill btn-full"
                            onClick={() => onAuditTrail()}
                        >
                            <Audit style={{ marginRight: '5px' }} />{t('protocols.visitTracking.auditTrail')}
                        </button>
                    }
                </Fragment>
            }
        />
    );
}

FormActions.propTypes = {
  onSave: PropTypes.func.isRequired,
  onSkip: PropTypes.func.isRequired,
  onScreenFailure: PropTypes.func.isRequired,
  onLostToFollowUp: PropTypes.func.isRequired,
  onWithoutDrugs: PropTypes.func.isRequired,
  onAuditTrail: PropTypes.func.isRequired,
  visit: PropTypes.object.isRequired,
  hasVisitTracking: PropTypes.bool.isRequired,
  forms: PropTypes.array.isRequired
};

export const FormHeader = (props) => {
  const {
    protocolId,
    patientId,
    visits
  } = props;


  if (!visits)
    return <Card
      className="card-visitTracking-header"
      noHeader
      content={<></>}
    />;

  const getVisitStatus = (status) => {
    switch (status) {
      case visitStatus.Started: return "visit-started";
      case visitStatus.Completed: return "visit-completed";
      case visitStatus.Skipped: return "visit-skipped";
      case visitStatus.Failed: return "visit-failed";
      case visitStatus.AutoCompleted: return "visit-timeclosed";
      default: return "";
    }
  }

    const Menu = () =>
        visits?.map((visit, index) => {
            if (visit.visitType == visitTypes.ProtocolVisit)
                return (
                    <div key={`header-visits-${index}`} className={"header-visit-container " + getNavLinkClass(`/admin/protocols/${protocolId}/visitTracking/${visit.crossVersionId}/patient/${patientId}`)}>
                        <NavLink to={`/admin/protocols/${protocolId}/visitTracking/${visit.crossVersionId}/patient/${patientId}`} className={getVisitStatus(visit.status) + " nav-link"} activeClassName="active">
                            <Tooltip tooltip={visitStatusFormatter(visit.status)} id={"tooltipviewHeader-" + visit.id}>
                                {visit.title} {visit.type === 1 && <Phone style={{ height: '20px', width: '20px', verticalAlign: 'bottom' }} />}
                                {visit.type === 2 && <VideoCall style={{ height: '20px', width: '20px', verticalAlign: 'bottom' }} />}
                            </Tooltip>
                        </NavLink>
                    </div>
                );
            else
                return (
                    <div key={`header-visits-${index}`} className={"header-visit-container " + getNavLinkClass(`/admin/protocols/${protocolId}/visitTrackingExtra/${visit.id}/patient/${patientId}`)}>
                        <NavLink to={`/admin/protocols/${protocolId}/visitTrackingExtra/${visit.id}/patient/${patientId}`} className="nav-link" activeClassName="active">
                            <Tooltip tooltip={getVisitTypeTitle(visit.visitType)} id={"tooltipviewHeader-" + visit.id}>
                                <ExtraProtocol style={{ cursor: "pointer" }} />
                                {visit.type === 1 && (
                                    <Phone style={{ height: '20px', width: '20px', verticalAlign: 'bottom' }} />
                                )}
                                {visit.type === 2 && (
                                    <VideoCall style={{ height: '20px', width: '20px', verticalAlign: 'bottom' }} />
                                )}
                            </Tooltip>
                        </NavLink>
                    </div>
                );
        });

  const ArrowLeft = <Back />;
  const ArrowRight = <Next />;

  const getNavLinkClass = (path) => {
    return window.location.pathname.toLowerCase() === path.toLowerCase() ? 'active' : '';
  }

  return (
    <Card
      className="card-visitTracking-header"
      noHeader
      content={
        <ScrollMenu
          data={Menu()}
          arrowLeft={ArrowLeft}
          arrowRight={ArrowRight}
          selected={null}
          onSelect={null}
          hideSingleArrow={true}
        />
      }
    />
  );
}

FormHeader.propTypes = {
  protocolId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  patientId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  visits: PropTypes.array,
};

export const VisitStatus = ({ status, date }) => {
  const { t } = useTranslation();
  switch (status) {
    case visitStatus.Started:
      return (<Alert bsStyle="info">[<Italic>{toLocaleDateTimeFormatter(date)}</Italic>] {t("protocols.visit.status.started")}</Alert>);
    case visitStatus.Completed:
      return (<Alert bsStyle="success">{t("protocols.visit.status.completed")}</Alert>);
    case visitStatus.Skipped:
      return (<Alert bsStyle="warning">{t("protocols.visit.status.skipped")}</Alert>);
    case visitStatus.Failed:
      return (<Alert bsStyle="danger">{t("protocols.visit.status.failed")}</Alert>);
    case visitStatus.Changed:
      return (<Alert bsStyle="warning">{t("protocols.visit.status.changed")}</Alert>);
    case visitStatus.AutoCompleted:
      return (<Alert className="montoto">{t("protocols.visit.status.autoCompleted")}</Alert>);
    default:
      return null;
  }
}

VisitStatus.propTypes = {
  status: PropTypes.string,
};
